import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Box, IconButton } from '@mui/material';
import { motion } from 'framer-motion';

export const SocialLinks = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '15px',
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        zIndex: 10,
      }}
    >
      <IconButton
        component={motion.button}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        sx={{ color: '#ffffff' }}
        onClick={() => window.open('https://instagram.com', '_blank')}
      >
        <InstagramIcon />
      </IconButton>
      <IconButton
        component={motion.button}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        sx={{ color: '#ffffff' }}
        onClick={() => window.open('https://twitter.com', '_blank')}
      >
        <TwitterIcon />
      </IconButton>
    </Box>
  );
};
